export enum GfrItem {
  CountryRiskContrib = 'eq_country_risk_contrib',
  FundamentalRiskContrib = 'eq_fundamental_risk_contrib',
  IndustryRiskContrib = 'eq_industry_risk_contrib',
  RegionRiskContrib = 'eq_region_risk_contrib',
  OtherSpreadRiskContrib = 'fi_other_risk_contrib',
  QualityRiskContrib = 'fi_quality_risk_contrib',
  SectorRiskContrib = 'fi_sector_risk_contrib',
  YieldCurveRiskContrib = 'yield_curve_risk_contrib',
  AltRiskContrib = 'alternatives_risk_contrib',
  CommodityRiskContrib = 'commodity_risk_contrib',
  SpecificRiskContrib = 'specific_risk_contrib',
  ModelRiskContrib = 'model_risk_contrib',
  CurrencyRiskContrib = 'currency_risk_contrib',
  SecurityRiskContrib = 'security_risk_contrib',
  SecurityRisk = 'security_risk',
  ModelRisk = 'model_risk',
  SpecificRisk = 'specific_risk',
}

const GfrItemValues = Object.values(GfrItem)
export function isGfrItem(value: string): value is GfrItem {
  return GfrItemValues.includes(value as any)
}
export type GfrUnit = 'bps' | '%'

export type GfrItemMetadata = {
  title: string
  header: string
  shortened?: string
  description: string
  unit: GfrUnit
  displayPrecision?: number
}

export const GfrItemDisplayLookup: Record<GfrItem, GfrItemMetadata> = {
  [GfrItem.CountryRiskContrib]: {
    title: 'Country Risk Contrib',
    header: 'Country Risk Contribution (bps)',
    shortened: 'Country Risk Cont (bps)',
    description: 'Country Risk Contribution (bps)',
    unit: 'bps',
  },
  [GfrItem.FundamentalRiskContrib]: {
    title: 'Style Risk Contrib',
    header: 'Style Risk Contribution (bps)', // ANP-2108. Style to match Factor Lens->Factor Breakdown->Style
    shortened: "Style Risk Cont (bps)",
    description: 'Style Risk Contribution (bps)',
    unit: 'bps',
  },
  [GfrItem.IndustryRiskContrib]: {
    title: 'Industry Risk Contrib',
    header: 'Industry Risk Contribution (bps)',
    shortened: "Industry Risk Cont (bps)",
    description: 'Industry Risk Contribution (bps)',
    unit: 'bps',
  },
  [GfrItem.RegionRiskContrib]: {
    title: 'Region Risk Contrib',
    header: 'Region Risk Contribution (bps)',
    shortened: "Region Risk Cont (bps)",
    description: 'Region Risk Contribution (bps)',
    unit: 'bps',
  },
  [GfrItem.OtherSpreadRiskContrib]: {
    title: 'Other Spread Risk Contrib',
    header: 'Other Spread Risk Contribution (bps)',
    shortened: "Other Spd Risk Cont (bps)",
    description: 'Other Spread Risk Contribution (bps)',
    unit: 'bps',
  },
  [GfrItem.QualityRiskContrib]: {
    title: 'Quality Risk Contrib',
    header: 'Quality Risk Contribution (bps)',
    shortened: 'Quality Risk Cont (bps)',
    description: 'Quality Risk Contribution (bps)',
    unit: 'bps',
  },
  [GfrItem.SectorRiskContrib]: {
    title: 'Sector Risk Contrib',
    header: 'Sector Risk Contribution (bps)',
    shortened: 'Sector Risk Cont (bps)',
    description: 'Sector Risk Contribution (bps)',
    unit: 'bps',
  },
  [GfrItem.YieldCurveRiskContrib]: {
    title: 'Yield Risk Contrib',
    header: 'Yield Risk Contribution (bps)',
    shortened: 'Yld Risk Cont (bps)',
    description: 'Yield Risk Contribution (bps)',
    unit: 'bps',
  },
  [GfrItem.AltRiskContrib]: {
    title: 'Alternative Risk Contrib',
    header: 'Alternative Risk Contribution (bps)',
    shortened: 'Alt Risk Cont (bps)',
    description: '',
    unit: 'bps',
  },
  [GfrItem.CommodityRiskContrib]: {
    title: 'Commodity Risk Contrib',
    header: 'Commodity Risk Contribution (bps)',
    shortened: 'Cmdty Risk Cont (bps)',
    description: '',
    unit: 'bps',
  },
  [GfrItem.SpecificRiskContrib]: {
    title: 'Specific Risk Contrib',
    header: 'Specific Risk Contribution (bps)',
    shortened: 'Specific Risk Cont (bps)',
    description: '',
    unit: 'bps',
  },
  [GfrItem.ModelRiskContrib]: {
    title: 'Model Risk Contrib',
    header: 'Model Risk Contribution (bps)',
    shortened: 'Model Risk Cont (bps)',
    description: '',
    unit: 'bps',
  },
  [GfrItem.CurrencyRiskContrib]: {
    title: 'Currency Risk Contrib',
    header: 'Currency Risk Contribution (bps)',
    shortened: "CCY Risk Cont (bps)",
    description: '',
    unit: 'bps',
  },
  [GfrItem.SecurityRiskContrib]: {
    title: 'Security Risk Contrib',
    header: 'Security Risk Contribution (bps)',
    shortened: 'Sec Risk Cont (bps)',
    description: '',
    unit: 'bps',
  },
  [GfrItem.SecurityRisk]: {
    title: '',
    header: 'Security Risk (%)',
    description: 'Security Risk (%)',
    unit: '%',
  },
  [GfrItem.ModelRisk]: {
    title: '',
    header: 'Model Risk (%)',
    description: 'Model Risk (%)',
    unit: '%',
  },
  [GfrItem.SpecificRisk]: {
    title: '',
    header: 'Specific Risk (%)',
    description: 'Specific Risk (%)',
    unit: '%',
  },
}
export function getGfrItemMetadata(item: GfrItem) {
  return GfrItemDisplayLookup[item]
}
